let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kUiUR")).then(() => parcelRequire('8lWE8'));